<template>
  <el-select v-bind="$attrs"
             :value="value"
             :multiple="multiple"
             :filter-method="filter"
             :clearable="clearable"
             @click.native="onClick"
             @change="onChange"
             @visible-change="onOpen"
  >
    <el-option-group v-for="group in portGroups"
                     :key="group.label"
                     :label="group.label">
      <el-option
        v-for="item in group.options"
        v-if="(!exceptions || (exceptions && exceptions.indexOf(item.id) < 0) || (exceptions && exceptions.indexOf(item.id) >= 0 && !item.isPort))"
        :key="item.id"
        :label="labelKey === 'code-label' ? (item.labels.code + ' (' + item.labels.label + ')') : item.labels[labelKey]"
        :value="item.id"
        :disabled="((!canChooseCity && !item.isPort) || (exceptions && exceptions.indexOf(item.id) >= 0 && !item.isPort))"
        :class="{ 'child': item.isChild, 'city': !item.isPort }"
      >
        <slot>
          <span class="option-label">{{ item.labels.label }}</span>
          <template v-if="showCompanies">
            <el-tag v-for="ak in item.aircompanies" :key="ak" type="warning" effect="plain" size="mini">
              {{ ak }}
            </el-tag>
          </template>
          <span class="option-code">{{ item.labels.code }}</span>
        </slot>
      </el-option>
    </el-option-group>
  </el-select>
</template>

<script>
import { filterPorts, getRecentPorts, addRecentPortById } from '@/utils/ports'
import includes from 'lodash/includes'

const defaults = {
  filterable: true,
  'automatic-dropdown': true,
  'default-first-option': true
}

export default {
  name: 'PortSelect',
  props: {
    value: {
      default: null
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    useRecent: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    canChooseCity: {
      type: Boolean,
      default: false
    },
    showCompanies: {
      type: Boolean,
      default: false
    },
    exceptions: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      attrs: {},
      portGroups: []
    }
  },
  created () {
    this.attrs = Object.assign({}, defaults, this.$attrs)
    this.filter()
  },
  methods: {
    onChange (value) {
      this.debug && console.log('onChange: %o', value)
      this.debug && console.log('this.portGroups[0].options: %o', this.portGroups[0].options)
      // NOTE: if port is deselected then value eq empty string. Therefore it needs to be converted to null
      if (Array.isArray(value)) {
        value.forEach(item => {
          isNaN(parseInt(item)) && (item = null)
          !item && addRecentPortById(item)
        })
      } else {
        isNaN(parseInt(value)) && (value = null)
        !value && addRecentPortById(value)
      }
      this.$emit('input', value)
      this.$emit('change', value, this.portGroups[0].options)
      this.filter()
    },
    filter (queryValue) {
      this.debug && console.log('queryValue: %o', queryValue)
      // search ports
      let filteredPorts = filterPorts(queryValue)

      if (this.useRecent) {
        // TODO: to be reimplemented
        /*let recentPorts = getRecentPorts().filter(r => includes(filteredPorts, r))
        const recentIds = recentPorts.map(p => p.id)
        filteredPorts = filteredPorts.filter(p => recentIds.indexOf(p.id) < 0)*/
      }

      // TODO: reimplement only for recent ports
      // up current value
     /* const currentValueIndex = filteredPorts.map(p => p.id).indexOf(this.value)
      if (currentValueIndex > -1) {
        const curPort = filteredPorts.splice(currentValueIndex, 1)
        filteredPorts.unshift(...curPort)
      }*/

      // prepare result
      let res = []
        /*
      if (this.useRecent) {
        if (recentPorts.length > 0) {
          res.push({label: this.$t('common.recent'), options: recentPorts})
        }
      }*/
      res.push({ label: '', options: filteredPorts })
      this.portGroups = res
    },
    onOpen (isOpen) {
      if (isOpen) {
        this.filter()
      } else {
        this.query = ''
      }
    },
    clearQuery () {
      this.$nextTick(() => {
        this.query = ''
      })
    },
    onClick (e) {
      let evt = new MouseEvent('click', e)
      this.$el.parentNode.dispatchEvent(evt)
    }
  }
}
</script>

<style scoped>
  .child {
    margin-left: 1.5rem;
  }
  .option-label {
    float: left;
    margin-right: 0.5rem;
  }
  .option-code {
    float: right;
    color: #8492a6;
    font-size: 0.8em;
    margin-left: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/PortSelect.vue